import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, FormsModule } from '@angular/forms';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Component({
  selector: 'app-opt-out-consequence',
  templateUrl: './opt-out-consequence.component.html',
  styleUrls: ['./opt-out-consequence.component.scss'],
})
export class OptOutConsequenceComponent {
  @Input() optOut: any;
  faTimes = faTimes;
  faPlus = faPlus;
  @Input() endpointTypes: any;
  @Output() public inputChangeEmitter: EventEmitter<any> = new EventEmitter(true);
  debouncer: Subject<string> = new Subject<string>();

  constructor(
    private router: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private formsModule: FormsModule,
    private modalHelper: NgbModal
  ) {
    this.debouncer.pipe(debounce(() => interval(1000))).subscribe((value) => this.inputChangeEmitter.emit(value));
  }

  initConsequenceObject(): void {
    var tmpObj = {
      class: 'com.chiprewards.cheetah.business.rules.config.behavior.v2.BehaviorConfiguration$Consequences$OptOut',
    };
    if (this.optOut) {
      this.optOut.push(tmpObj);
    } else {
      this.optOut = [];
      this.optOut.push(tmpObj);
    }
    console.log(this.optOut);
  }

  updateConsequences() {
    this.debouncer.next(this.optOut);
  }

  removeConsequence(consequence) {
    this.optOut.splice(this.optOut.indexOf(consequence), 1);
    this.updateConsequences();
  }
}
